// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsReflector_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M18.0203 12.0408C18.0203 15.3544 15.3249 18.0406 11.9998 18.0406C8.67483 18.0406 5.97937 15.3544 5.97937 12.0408C5.97937 8.72713 8.67483 6.04089 11.9998 6.04089C15.3249 6.04089 18.0203 8.72713 18.0203 12.0408Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0.000244136 10.9997C0.482846 5.17008 5.14674 0.52207 10.9963 0.0410148V2.04938C6.25581 2.51843 2.48589 6.27541 2.01515 10.9997H0.000244136Z" fill="#3AD2A3"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M23.9997 10.9997C23.5171 5.17001 18.8531 0.521951 13.0034 0.0410148V2.04928C17.7439 2.51834 21.5138 6.27537 21.9845 10.9997H23.9997Z" fill="#ED5353"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.0034 23.9585C18.8532 23.4776 23.5173 18.8295 23.9999 12.9999H21.9846C21.5139 17.7241 17.7439 21.4812 13.0034 21.9502V23.9585ZM12.0002 0L12.0551 0.000122068H11.9453L12.0002 0Z" fill="#FDCA40"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9451 0.0411369H12.0549L12 0.0410148L11.9451 0.0411369ZM10.9965 21.9912V23.9994C5.14686 23.5185 0.482886 18.8705 0.000244136 13.0409H2.01526C2.48598 17.7652 6.25595 21.5222 10.9965 21.9912Z" fill="#EF8354"/>
</svg>
`;
/**
 * IconRmsReflector is a generated icon component.
 */
let IconRmsReflector = IconRmsReflector_1 = class IconRmsReflector extends IconBaseElement {
    render() {
        return html `${IconRmsReflector_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsReflector.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconRmsReflector = IconRmsReflector_1 = __decorate([
    customElement('zui-icon-rms-reflector')
], IconRmsReflector);
export { IconRmsReflector };
